import PropTypes from 'prop-types';
import React from 'react';
import Button from 'react-bootstrap/lib/Button';
import Icon from 'components/Icon/Icon';

const DeclinePitch = ({ onCancel, onDecline }) => {
  return (
    <div>
      <p style={{ textAlign: 'center', fontSize: '26px' }}>
        <strong>Remove Freelancer</strong>
      </p>
      <div style={{ textAlign: 'center', fontSize: '400%', margin: 0 }}>
        <Icon color="#d9534f" icon="&#xe633;" />
      </div>
      <p style={{ textAlign: 'center' }}>
        Notify the freelancer that you're not working with them for this job.
      </p>
      <p style={{ textAlign: 'center' }}>
        You can still favourite or hire them on future jobs.
      </p>
      <p style={{ textAlign: 'center' }} className="mt">
        <Button style={{ marginRight: 50 }} bsStyle="info" onClick={onCancel}>
          Cancel
        </Button>
        <Button style={{ marginLeft: 50 }} bsStyle="danger" onClick={onDecline}>
          Remove freelancer
        </Button>
      </p>
    </div>
  );
};

DeclinePitch.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
};

export default DeclinePitch;
